import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, BUSINESS_TYPES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'businessType',
  url: `${BUSINESS_TYPES_URL}/:id`,
  headers,
  actions: {
    createMany: {
      gerundName: 'creatingMany',
      isArray: true,
      method: 'POST',
      url: `${BUSINESS_TYPES_URL}/many`,
    },
    fetch: {
      transformResponse,
    },
  },
});
